import React, { useState, useRef } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase';
import { Link } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';


function ForgotPassword({ loadingBarRef }) { // Accept loadingBarRef as prop
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [captchaValue, setCaptchaValue] = useState(null);
  const recaptchaRef = useRef();
  const [buttonText, setButtonText] = useState('Reset Password');

  const handleReset = async (e) => {
    e.preventDefault();
    setButtonText('Resetting...');
    if (loadingBarRef.current) {
      loadingBarRef.current.continuousStart();
    }
    setTimeout(async () => {
      setButtonText('Reset Password');
      if (loadingBarRef.current) {
        loadingBarRef.current.complete();
      }

      if (!captchaValue) {
        setError("Please complete the captcha verification");
        return;
      }

      try {
        await sendPasswordResetEmail(auth, email);
        setMessage('Password reset email sent!');
        setError('');
      } catch (err) {
        setError(err.message);
        setMessage('');
        // Reset captcha on error
        recaptchaRef.current.reset();
        setCaptchaValue(null);
      }
    }, 2000); // 2-second delay
  };

  return (
    <div className="max-w-md mx-auto px-4 py-8">
      <h2 className="text-2xl font-bold mb-4">Forgot Password</h2>
      {message && <p className="text-green-500">{message}</p>}
      {error && <p className="text-red-500">{error}</p>}
      <form onSubmit={handleReset} className="space-y-4">
        <div>
          <label className="block text-gray-700">Email</label>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full border rounded px-3 py-2"
          />
        </div>
        <div className="flex justify-center my-4">
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey="6Leys3EqAAAAAEjkHcbcAjaoJ1Bf4o1xcG8W1Hv9"
            onChange={(value) => setCaptchaValue(value)}
            size="normal"
            className="transform scale-90 sm:scale-100"
          />
        </div>
        <button 
          type="submit" 
          className={`w-full bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700 disabled:bg-indigo-400 transition-transform duration-300 ${
            !captchaValue ? 'cursor-not-allowed' : 'transform hover:scale-105'
          }`}
          disabled={!captchaValue}
        >
          {buttonText}
        </button>
      </form>
      <div className="mt-4 text-center">
        <Link to="/login" className="text-indigo-600 hover:underline">Back to Login</Link>
      </div>
    </div>
  );
}

export default ForgotPassword;
